module.exports = __webpack_public_path__ + "22f261d9c27589071ded9e8e5929954b.png";